import { AvpContextClaims } from '@org-avp/context-claims';
import type { Claims } from '@org-avp/context-claims';
import type { IBrand, IMarket } from 'data/schema';
import { isDealerIdFormatValid } from './dealerIdFormat';
import { validateDealerId } from './dealerIdValidator';

/** The account's Dealer IDs that parse to a known market and brand (see dealerIdFormat.ts). */
export const getFilteredDealerIds = (claims?: Claims): string[] => {
  if (!claims) return [];
  const dealerIds = AvpContextClaims.getDealerIds(claims);
  return dealerIds.filter((id) => isDealerIdFormatValid(id));
};

/** Format and brand/market only (AVS-4406): membership is the caller's concern, not this check's. */
export function isDealerIdEligible(dealerId: string, brand: IBrand, market: IMarket): boolean {
  return validateDealerId(dealerId, { brand, market }).ok;
}

/** The owned dealer IDs accepted for a brand and market, in account order. */
export function getEligibleDealerIds(dealerIds: readonly string[], brand: IBrand, market: IMarket): string[] {
  return dealerIds.filter((dealerId) => isDealerIdEligible(dealerId, brand, market));
}
